import ParamStore from '../stores/param-store';

export default class CoreParamManager {
    static validateAndStore(params, componentId) {
        CoreParamManager.validate(params);
        CoreParamManager.store(params, componentId);
    }

    static validate(params) {
        CoreParamManager._validateComponentParams(params);
        CoreParamManager._validateClsParams(params);
        CoreParamManager._validateErrorTrackingParams(params);
        CoreParamManager._validateSegmentTrackingParams(params);
    }

    static store(params, componentId) {
        let paramStoreModel = ParamStore.getModel(componentId);

        paramStoreModel.instanceId = params.instanceId;
        paramStoreModel.tracking = params.tracking;

        paramStoreModel.lang5 = params.lang5;
        paramStoreModel.rootUrl = params.rootUrl;

        if (params.initialCohort) {
            paramStoreModel.initialCohort = params.initialCohort;
        }

        if (params.targetCohort) {
            paramStoreModel.targetCohort = params.targetCohort;
        }

        paramStoreModel.clsEndpoint = params.clsEndpoint;
        paramStoreModel.clsClientId = params.clsClientId;
        paramStoreModel.clsReturnUrl = params.clsReturnUrl;
        paramStoreModel.clsLoginUrl = params.clsLoginUrl;
        paramStoreModel.targetUrl = params.targetUrl;

        paramStoreModel.websiteEndpoint = params.websiteEndpoint;
        paramStoreModel.disableRedirectToLogin = params.disableRedirectToLogin;
        paramStoreModel.disableKeepLoggedInCheckbox = params.disableKeepLoggedInCheckbox;

        // Tracking source overrides
        // Encode full URL as part of the returnUrl section and used to redirect not for XHRs.
        // Double encode sources for sure
        const registrationSourceURIPart =
            `registrationSource=${encodeURIComponent(params.tracking.segment.registrationSource)}`;
        const loginSourceURIPart =
            `&loginSource=${encodeURIComponent(params.tracking.segment.loginSource)}`;
        const targetUrlURIPart = paramStoreModel.targetUrl
                ? `&fwdto=${encodeURIComponent(params.targetUrl)}`
                : '';

        const clsUrlQueryString = `${registrationSourceURIPart}${loginSourceURIPart}${targetUrlURIPart}`;
        const encodedClsUrlQueryString = encodeURIComponent(clsUrlQueryString);

        paramStoreModel.clsAutoLoginReturnUrl =
            paramStoreModel.clsReturnUrl.replace('TRACKING_SOURCE_PLACEHOLDER', encodedClsUrlQueryString);

        paramStoreModel.clsReturnUrl =
            paramStoreModel.clsReturnUrl.replace('TRACKING_SOURCE_PLACEHOLDER', clsUrlQueryString);

        paramStoreModel.clsLoginUrl =
            paramStoreModel.clsLoginUrl.replace('TRACKING_SOURCE_PLACEHOLDER', encodedClsUrlQueryString);

        if (params.clsExecutionArea) {
            paramStoreModel.clsExecutionArea = params.clsExecutionArea;
        }

        paramStoreModel.sentryUrl = params.sentryUrl;
        paramStoreModel.userLogData = params.userLogData;

        if (params.callbacks) {
            paramStoreModel.callbacks = params.callbacks;
        }

        if (params.silentMode) {
            paramStoreModel.silentMode = params.silentMode;
        }
    }

    static warnImplementer(nonSupportedItem) {
        console.warn(`${nonSupportedItem} no longer supported!!!`);
    }

    static _validateComponentParams(params) {
        if (!params.instanceId) {
            throw new Error('JLS Missing obligatory global parameter called instanceId');
        }

        if (!params.rootUrl) {
            throw new Error('JLS Missing obligatory global parameter called rootUrl');
        }

        if (!params.lang5) {
            throw new Error('JLS Missing obligatory global parameter called lang5');
        }
    }

    static _validateClsParams(params) {
        if (!params.clsEndpoint) {
            throw new Error('JLS Missing obligatory global parameter called clsEndpoint');
        }

        if (!params.clsClientId) {
            throw new Error('JLS Missing obligatory global parameter called clsClientId');
        }

        if (!params.clsReturnUrl) {
            throw new Error('JLS Missing obligatory global parameter called clsReturnUrl');
        }

        if (!params.clsLoginUrl) {
            throw new Error('JLS Missing obligatory global parameter called clsLoginUrl');
        }
    }

    static _validateErrorTrackingParams(params) {
        if (!params.sentryUrl) {
            throw new Error('JLS Missing obligatory global parameter called sentryUrl');
        }

        if (!params.userLogData) {
            throw new Error('JLS Missing obligatory global parameter called userLogData');
        }

        if (!params.userLogData.anonymousId) {
            throw new Error('JLS Missing obligatory global parameter called userLogData.anonymousId');
        }

        if (!params.userLogData.lang) {
            throw new Error('JLS Missing obligatory global parameter called userLogData.lang');
        }
    }

    static _validateSegmentTrackingParams(params) {
        if (!params.tracking) {
            throw new Error('JLS Missing obligatory global parameter called tracking');
        }

        if (!params.tracking.segment) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment');
        }

        if (!params.tracking.segment.containerProperty) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.containerProperty');
        }

        if (!params.tracking.segment.registrationSource) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.registrationSource');
        }

        if (!params.tracking.segment.loginSource) {
            throw new Error('JLS Missing obligatory global parameter called tracking.segment.loginSource');
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/logic/params/core-param-manager.js
 **/